export const trackUserData = (userData) => {
    if (window.userpilot) {
        window.userpilot.identify(userData.UserId, {
            operatorPlan: userData.AccountPlan,
            isAdmin: userData.UserRole === 'Admin' || false
        })
    } else {
        console.info('Userpilot not intialized for tracking page authenticated user.')
    }
}

export const trackAnonymous = () => {
    if (window.userpilot) {
        window.userpilot.anonymous()
    } else {
        console.info('Userpilot not intialized anonymous user.')
    }
}